/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React from "react";
import FormFader from "../Common/Fader/FormFader";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";
import FormSubmit from "../Common/FormSubmit/FormSubmit";
import Hidden from "@mui/material/Hidden";
import { Box, Button } from "@mui/material";
import { useForm } from "../../../provider/Form/FormProvider";
import DialogModal from "../../DialogModal/DialogModal";
import { useLocation, useNavigate } from "react-router-dom";
import MoreInfoIcon from "../../SvgIcon/MoreInfoIcon";
import ValidatorTextField from "../../FormFields/ValidatorTextField";
import { requiredValidator } from "../../../services/validationRules";
import Typography from "@mui/material/Typography";
import FormLegend from "../Common/FormLegend/FormLegend";
import FormSubmitProps from "../../../types/FormSubmitProps";
import wizardStyle from "../wizardStyle";

type LegalExpensesInsuranceProps = {
  submitProps: FormSubmitProps;
};

export default function LegalExpensesInsurance({ submitProps }: LegalExpensesInsuranceProps) {
  const navigate = useNavigate();
  const location = useLocation();
  const { handleSubmit } = useForm();

  const modalOpen = () => {
    navigate(location.pathname, { state: { jobInfoModalOpen: true } });
  };

  const modalClose = () => {
    navigate(-1);
  };

  return (
    <Paper sx={wizardStyle.paper} elevation={4}>
      <FormFader>
        <Box component={"form"} sx={wizardStyle.wizardForm} onSubmit={handleSubmit}>
          <Hidden smUp>
            <Typography variant={"h4"} sx={wizardStyle.headline}>
              Persönliche Angaben
            </Typography>
          </Hidden>
          <Grid container justifyContent={"flex-start"} alignItems={"baseline"}>
            <Grid item xs={12} sx={wizardStyle.gridTopSpaced}>
              <FormLegend>
                Was ist Ihr aktueller Beruf?
                <Button fullWidth={true} variant={"text"} color={"primary"} onClick={modalOpen}>
                  <MoreInfoIcon sx={wizardStyle.leftIcon} /> Weitere Informationen
                </Button>
              </FormLegend>
            </Grid>
            <Grid item xs={12}>
              <ValidatorTextField name="job" label="Aktueller Beruf" validators={[requiredValidator("Bitte geben Sie Ihren aktuellen Beruf an")]} />
            </Grid>
          </Grid>
          <FormSubmit {...submitProps} />
        </Box>
      </FormFader>
      <DialogModal open={!!(location.state && location.state.jobInfoModalOpen)} onClose={modalClose} title={"Weitere Informationen"}>
        <p>
          Entscheidend ist dabei nur Ihr <strong>aktueller</strong> Beruf. Wenn Sie zum Beispiel ausgebildete Erzieherin sind und jetzt als Verkäuferin
          arbeiten, tragen Sie bitte Verkäuferin ein. Wenn Sie aktuell Hausfrau, arbeitslos oder freigestellt sind, können Sie das hier ebenfalls angeben.
        </p>
      </DialogModal>
    </Paper>
  );
}
